//import binaryParser from "superagent-binary-parser";
import * as superagent from 'superagent'
import Toast from './Toast'
import {env} from "../data/constants";

const API_TOKEN_KEY = 'nbu_api_token'
const API_TOKEN_TYPE_KEY = 'nbu_api_token_type'

export const setAuthToken = (token: string, tokenType: string = 'Bearer') => {
    localStorage.setItem(API_TOKEN_KEY, token)
    localStorage.setItem(API_TOKEN_TYPE_KEY, tokenType)
}

export const clearAuthToken = () => {
    localStorage.removeItem(API_TOKEN_KEY)
    localStorage.removeItem(API_TOKEN_TYPE_KEY)
}

export const getToken = (): string | null => {
    return localStorage.getItem(API_TOKEN_KEY)
}

export const getAuthHeader = (): string => {
    const tokenType = localStorage.getItem(API_TOKEN_TYPE_KEY) || 'Bearer'
    return `${tokenType} ${getToken() ?? ''}`
}

type CallbackFunction = (data?: any) => void;
type ErrorCallback = (err: any, res: superagent.Response) => void;
type EndCallback = (data?: any) => void;

export const handleError = (err: any = {}, res: superagent.Response) => {
    // const { enqueueSnackbar } = useSnackbar();
    const defaultMessage = "Invalid request, please contact admin";
    if ((res && res.forbidden) || (res && res.unauthorized)) {
        Toast.error("Authentication Error")
        
    } else if (res && res.badRequest) {
        const {message, errors} = res.body
        let msg = message||'' + '\n'
        for (const key in errors) {
            if (errors.hasOwnProperty(key)) {
                const error = errors[key][0]
                msg += (error + '\n')
            }
        }
        Toast.error(msg || defaultMessage)
        
    } else if ((res && res.clientError) || (res && res.notAcceptable) || (res && res.error)) {
        Toast.error(defaultMessage)
        
    } else if (res && res.body && res.body.message) {
        Toast.error(res.body.message)
        
    } else {
        const message = err.message || 'Unknown error, contact admin'
        const finalMessage = message.indexOf("offline") !== -1
            ? "Can't reach server, Check connectivity"
            : message
        Toast.error(finalMessage)
        // enqueueSnackbar(finalMessage, {
        //     variant: 'error',
        // });
    }
}

const timeout = 0
export const isAuthError = (err: any = {}, res: superagent.Response) => {
    if (err) {
        console.log(err)
        return false
    }
    return (res && res.forbidden) || (res && res.unauthorized)
}

export const handleResponse = (callBack: CallbackFunction, errorCallBack?: ErrorCallback, endCallBack?: EndCallback) => (
    err: any, res: superagent.Response) => {
    try {
        if (err || !res.ok) {
            // Unauthorized
            if (err?.response?.status === 401) {
                //window.location.reload();
            }
            if (errorCallBack) {
                errorCallBack(err, res)
            } else {
                handleError(err, res)
            }
        } else {
            callBack(res.body)
        }
    } catch (e) {
        console.error("Failed to process response", e)
    } finally {
        if (endCallBack) {
            endCallBack()
        }
    }
}

export const get = (url: string, callBack: CallbackFunction, errorCallBack?: ErrorCallback, endCallBack?: EndCallback) => {
    superagent.get(url)
        .set('Authorization', getAuthHeader())
        .set('Accept', 'application/json')
        .set('Ocp-Apim-Subscription-Key', `${env.skey}`)
        .timeout(timeout)
        .end(handleResponse(callBack, errorCallBack, endCallBack))
}

export const search = (url: string, data: any, callBack: CallbackFunction, errorCallBack?: ErrorCallback, endCallBack?: EndCallback) => {
    superagent.get(url)
        .set('Authorization', getAuthHeader())
        .set('Accept', 'application/json')
        .set('Ocp-Apim-Subscription-Key', `${env.skey}`)
        .query(data)
        .timeout(timeout)
        .end(handleResponse(callBack, errorCallBack, endCallBack))
}


export const post = (url: string, data: any, callBack: CallbackFunction, errorCallBack?: ErrorCallback, endCallBack?: EndCallback) => {
    superagent.post(url)
        .set('Authorization', getAuthHeader())
        .set('Accept', 'application/json')
        .set('Content-Type', 'application/json')
        .set('Ocp-Apim-Subscription-Key', `${env.skey}`)
        .send(data)
        .timeout(timeout)
        .end(handleResponse(callBack, errorCallBack, endCallBack))
}

export const postFile = (url: string, data: any, callBack: CallbackFunction, errorCallBack?: ErrorCallback, endCallBack?: EndCallback) => {
    superagent.post(url)
        .set('Authorization', getAuthHeader())
        .set('Ocp-Apim-Subscription-Key', `${env.skey}`)
        .send(data)
        .timeout(timeout)
        .end(handleResponse(callBack, errorCallBack, endCallBack))
}

export const put = (url: string, data: any, callBack: CallbackFunction, errorCallBack?: ErrorCallback, endCallBack?: EndCallback) => {
    superagent.put(url)
        .set('Authorization', getAuthHeader())
        .set('Content-Type', 'application/json')
        .set('Accept', 'application/json')
        .set('Ocp-Apim-Subscription-Key', `${env.skey}`)
        .send(data)
        .timeout(timeout)
        .end(handleResponse(callBack, errorCallBack, endCallBack))
}

export const del = (url: string, callBack: CallbackFunction, errorCallBack?: ErrorCallback, endCallBack?: EndCallback) => {
    superagent.delete(url)
        .set('Authorization', getAuthHeader())
        .set('Accept', 'application/json')
        .set('Ocp-Apim-Subscription-Key', `${env.skey}`)
        .timeout(timeout)
        .end(handleResponse(callBack, errorCallBack, endCallBack))
}

export const downLoad = (url: string, callBack: CallbackFunction, errorCallBack?: ErrorCallback, endCallBack?: EndCallback) => {
    superagent.get(url)
        .set('Authorization', getAuthHeader())
        .set('Ocp-Apim-Subscription-Key', `${env.skey}`)
        .responseType('blob')
        .end(handleResponse(callBack, errorCallBack, endCallBack))
}

export const generatePDF = (url: string, data: any, callBack: CallbackFunction, errorCallBack?: ErrorCallback, endCallBack?: EndCallback) => {
    superagent.post(url)
        .set('Authorization', getAuthHeader())
        .set('Accept', 'application/json')
        .set('Ocp-Apim-Subscription-Key', `${env.skey}`)
        .send(data)
        //.timeout(timeout)
        .responseType('blob')
        .end(handleResponse(callBack, errorCallBack, endCallBack))
}

export const triggerDownLoad = (data: Blob, fileName = 'export.pdf') => {
    const a = document.createElement('a');
    a.href = window.URL.createObjectURL(data);
    a.download = fileName;
    a.click();
}

export const generateFilePath = (data: Blob) => {
    const a = document.createElement('a')
    return window.URL.createObjectURL(data)
}